import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { UserDevice } from "types/user.types";
import {
  DeviceSection,
  DeviceCard,
  DeviceInfo,
  DeviceSerial,
  DeviceInputRow,
  SectionTitle,
  ActionCardTitle,
  ActionCardDescription,
  FormField,
  FormLabel,
} from "styles/components/userDetails.styles";
import { buildDeviceDetailsPath } from "utils/deviceNavigation";

interface Props {
  device: UserDevice | null;
  isLinking: boolean;
  isUnlinking: boolean;
  onLink: (serialNumber: string) => void;
  onUnlink: () => void;
}

const UserDeviceTab: React.FC<Props> = ({
  device,
  isLinking,
  isUnlinking,
  onLink,
  onUnlink,
}) => {
  const navigate = useNavigate();
  const [serialInput, setSerialInput] = useState("");

  const handleLink = () => {
    onLink(serialInput);
    setSerialInput("");
  };

  return (
    <DeviceSection style={{ marginTop: "1rem" }}>
      <SectionTitle>
        <i className="pi pi-tablet" />
        Device Management
      </SectionTitle>

      <DeviceCard>
        {device?.serialNumber ? (
          <>
            <ActionCardTitle>Current Linked Device</ActionCardTitle>
            <DeviceInfo>
              <i
                className="pi pi-tablet"
                style={{ color: "#00747A", fontSize: "1.25rem" }}
              />
              <DeviceSerial
                onClick={() =>
                  navigate(
                    buildDeviceDetailsPath({
                      serialNumber: device.serialNumber,
                      isAdminView: true,
                    }),
                  )
                }
              >
                {device.serialNumber}
              </DeviceSerial>
            </DeviceInfo>
            <ActionCardDescription>
              Remove the device link so this user is no longer associated with
              this device.
            </ActionCardDescription>
            <Button
              label="Unlink Device"
              icon="pi pi-times"
              className="p-button-danger p-button-outlined"
              onClick={onUnlink}
              loading={isUnlinking}
              style={{ alignSelf: "flex-start" }}
            />
          </>
        ) : (
          <>
            <ActionCardTitle>Link a Device</ActionCardTitle>
            <ActionCardDescription>
              Enter the device serial number to link it to this user.
            </ActionCardDescription>
            <DeviceInputRow>
              <FormField style={{ flex: 1 }}>
                <FormLabel htmlFor="serial-input">Serial Number</FormLabel>
                <InputText
                  id="serial-input"
                  value={serialInput}
                  onChange={(e) => setSerialInput(e.target.value)}
                  placeholder="e.g. SN-001"
                  style={{ width: "100%" }}
                />
              </FormField>
              <Button
                label="Link Device"
                icon="pi pi-link"
                onClick={handleLink}
                loading={isLinking}
                disabled={!serialInput.trim()}
              />
            </DeviceInputRow>
          </>
        )}
      </DeviceCard>
    </DeviceSection>
  );
};

export default UserDeviceTab;
